export const formConfig = [
  {
    key: 'ExtField1',
    Name: '选择会议',
    EName: 'Select Conference',
    Holder: '请选择',
    EHolder: 'please enter filed1',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 0,
    Options: 'D;E;F',
    EOptions: null
  },
  {
    key: 'Name',
    Name: '姓名',
    EName: 'Full Name',
    Holder: '请输入您的姓名',
    EHolder: 'Please enter your name',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'Province',
    Name: '省份',
    EName: 'Province',
    Holder: '请选择您的省份',
    EHolder: 'Please choose your province',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 2,
    Options: null,
    EOptions: null
  },
  {
    key: 'City',
    Name: '城市',
    EName: 'City',
    Holder: '请选择您的城市',
    EHolder: 'Please choose your city',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 3,
    Options: null,
    EOptions: null
  },
  {
    key: 'ComName',
    Name: '单位',
    EName: 'Organization',
    Holder: '请输入单位',
    EHolder: 'Please enter your Organization',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 4,
    Options: null,
    EOptions: null
  },
  {
    key: 'Rank',
    Name: '职务',
    EName: 'Job Title',
    Holder: '请输入您的职务',
    EHolder: 'Please enter your Job Title',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 5,
    Options: null,
    EOptions: null
  },
  {
    key: 'Email',
    Name: '邮箱',
    EName: 'Email',
    Holder: '请输入您的邮箱',
    EHolder: 'Please enter your email',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 6,
    Options: null,
    EOptions: null
  },
  {
    key: 'IDCardType',
    Name: '身份证件类型',
    EName: 'ID Type',
    Holder: '请选择',
    EHolder: '',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 7,
    Options: '',
    EOptions: null
  },
  {
    key: 'IDCardNo',
    Name: '证件号码',
    EName: 'ID Number',
    Holder: '请输入您的证件号码',
    EHolder: 'Please enter your ID Number',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 8,
    Options: null,
    EOptions: null
  },
  {
    key: 'Trade',
    Name: '行业',
    EName: 'Industry category',
    Holder: '请选择行业',
    EHolder: 'Please choose your Industry category',
    IsMust: false,
    EIsMust: false,
    IsShow: false,
    EisShow: false,
    Sort: 8,
    Options:
      '法人代表;董事长;总裁;首席执行官;总经理;副总经理;店主/老板;采购商/供应链;产品开发;商协会;总监;经理;主管',
    EOptions: null
  },
  {
    key: 'Mobile',
    Name: '手机',
    EName: 'Mobile',
    Holder: '请输入您的手机',
    EHolder: 'Please enter your mobile',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 9,
    Options: null,
    EOptions: null
  },
  {
    key: 'WebUrl',
    Name: '网址',
    EName: 'WebUrl',
    Holder: '请输入您的公司网址',
    EHolder: 'Please enter your weburl',
    IsMust: false,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'Photo',
    Name: '头像',
    EName: 'Photo',
    Holder: '',
    EHolder: '',
    IsMust: false,
    EIsMust: false,
    IsShow: false,
    EisShow: false,
    Sort: 1,
    Options: '',
    EOptions: null
  },
  {
    key: 'Remark',
    Name: '备注',
    EName: 'Remark',
    Holder: '请输入备注',
    EHolder: 'Please enter your remark',
    IsMust: true,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'ZipCode',
    Name: '邮编',
    EName: 'ZipCode',
    Holder: '请输入您的邮编地址',
    EHolder: 'Please enter your zipcode',
    IsMust: true,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },

  {
    key: 'Tel',
    Name: '电话',
    EName: 'Tel',
    Holder: '请输入您的电话',
    EHolder: 'Please enter your tel',
    IsMust: true,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'Fax',
    Name: '传真',
    EName: 'Fax',
    Holder: '请输入您的传真',
    EHolder: 'Please enter your fax',
    IsMust: true,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },

  {
    key: 'Address',
    Name: '地址',
    EName: 'Address',
    Holder: '请输入您的地址',
    EHolder: 'Please enter your address',
    IsMust: false,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },

  {
    key: 'Country',
    Name: '国家',
    EName: 'Country',
    Holder: '请选择您的国家',
    EHolder: 'Please choose your country',
    IsMust: true,
    EIsMust: true,
    IsShow: false,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'Dept',
    Name: '部门',
    EName: 'Dept',
    Holder: '请输入您的部门',
    EHolder: 'Please enter your dept',
    IsMust: false,
    EIsMust: false,
    IsShow: false,
    EisShow: false,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'Gender',
    Name: '性别',
    EName: 'Gender',
    Holder: '请选择您的性别',
    EHolder: 'Please choose your gender',
    IsMust: false,
    EIsMust: false,
    IsShow: false,
    EisShow: false,
    Sort: 1,
    Options: null,
    EOptions: null
  }
]

export const quesConfig = [
  {
    Question_QusType: 'M',
    QuestionsID: 195,
    QuestionsQusETitle: 'ganization Type',
    QuestionsQusTitle: '企业/单位类型',
    Questions_IsRequired: true,
    Questions_MaxAnsCount: null,
    Questions_MinAnsCount: null,
    Questions_Sort: 1,
    checked: [],
    AnswersCollect: [
      {
        AnswersEInputText: null,
        AnswersETitle: 'Government & Regulatory Authorities',
        AnswersID: 2365,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 1,
        AnswersTitle: '政府及监管机构',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Universities & Research Institutes',
        AnswersID: 2366,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 2,
        AnswersTitle: '高校及科研院所',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Industry Associations',
        AnswersID: 2367,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 3,
        AnswersTitle: '行业组织',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Enterprises',
        AnswersID: 2368,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 4,
        AnswersTitle: '企业',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Consulting Firms',
        AnswersID: 2369,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 6,
        AnswersTitle: '咨询机构',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Financial Institutions',
        AnswersID: 2370,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 7,
        AnswersTitle: '金融机构',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Embassies, Consulates & International Organizations',
        AnswersID: 2436,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 7,
        AnswersTitle: '使领馆及国际机构',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
      ,
      {
        AnswersEInputText: null,
        AnswersETitle: 'Industrial Parks',
        AnswersID: 2437,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 7,
        AnswersTitle: '产业园区',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
      ,
      {
        AnswersEInputText: null,
        AnswersETitle: 'Media',
        AnswersID: 2650,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 7,
        AnswersTitle: '媒体',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
      ,
      {
        AnswersEInputText: null,
        AnswersETitle: 'Others',
        AnswersID: 24373,
        AnswersInputText: null,
        AnswersIsInput: true,
        AnswersSort: 7,
        AnswersTitle: '其他',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
    ]
  },
  {
    Question_QusType: 'S',
    QuestionsID: 215,
    QuestionsQusETitle: 'Is your organization involved in hydrogen-related business?',
    QuestionsQusTitle: '您的企业是否涉及氢能相关业务',
    Questions_IsRequired: true,
    Questions_MaxAnsCount: null,
    Questions_MinAnsCount: null,
    Questions_Sort: 1,
    checked: '',
    AnswersCollect: [
      {
        AnswersEInputText: null,
        AnswersETitle: 'Yes',
        AnswersID: 2651,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 1,
        AnswersTitle: '是',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'No',
        AnswersID: 2652,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 2,
        AnswersTitle: '否',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }         
      
    ]
  },
  {
    Question_QusType: 'M',
    QuestionsID: 196,
    QuestionsQusETitle: 'Which segments does your organization belong to?',
    QuestionsQusTitle: '您的企业/单位属于产业链的哪些环节？',
    Questions_IsRequired: true,
    Questions_MaxAnsCount: null,
    Questions_MinAnsCount: null,
    Questions_Sort: 2,
    checked: [],
    AnswersCollect: [
      {
        AnswersEInputText: null,
        AnswersETitle: 'Hydrogen Production (e.g. water electrolysis, biomass-based hydrogen production, solar thermal / wind-powered hydrogen production)',
        AnswersID: 2371,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 1,
        AnswersTitle: '制氢技术（如电解水、生物质制氢、光热/风电制氢）',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Hydrogen Storage & Transportation (e.g. storage cylinders, liquid hydrogen tanks, hydrogen pipelines, etc.)',
        AnswersID: 2372,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 2,
        AnswersTitle: '储运技术（储氢瓶、液氢储罐、输氢管线等）',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Fuel Cell Systems & Key Components (stacks, membrane electrode assemblies (MEAs), catalysts, etc.)',
        AnswersID: 2373,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 3,
        AnswersTitle: '燃料电池系统及核心部件（电堆、膜电极、催化剂等）',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Hydrogen Refueling Station (compression systems, metering devices, safety monitoring, etc.)',
        AnswersID: 2374,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 4,
        AnswersTitle: '加氢站设备（压缩系统、计量装置、安全监控等）',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Hydrogen Application Scenarios (transportation, industry, power generation, aerospace, etc.)',
        AnswersID: 2375,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 5,
        AnswersTitle: '氢能应用场景（交通、工业、电力、航空航天等）',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Testing, Certification & Consulting Services',
        AnswersID: 2376,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 6,
        AnswersTitle: '检测认证与咨询服务',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Others',
        AnswersID: 2377,
        AnswersInputText: null,
        AnswersIsInput: true,
        AnswersSort: 7,
        AnswersTitle: '其他',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
    ]
  },
  {
    Question_QusType: 'M',
    QuestionsID: 197,
    QuestionsQusETitle: 'What is your primary purpose for attending this event?',
    QuestionsQusTitle: '参加本次活动的主要目的是？',
    Questions_IsRequired: true,
    Questions_MaxAnsCount: null,
    Questions_MinAnsCount: null,
    Questions_Sort: 3,
    checked: [],
    AnswersCollect: [
      {
        AnswersEInputText: null,
        AnswersETitle: 'howcasing latest technologies / products',
        AnswersID: 2378,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 1,
        AnswersTitle: '展示最新技术/产品',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Seeking cooperation (technology collaboration, supply chain matching, etc.)',
        AnswersID: 2379,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 2,
        AnswersTitle: '寻求合作（技术合作、供应链对接等）',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Understanding industry policies & market trends',
        AnswersID: 2380,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 3,
        AnswersTitle: '了解行业政策与市场趋势',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Brand promotion & market expansion',
        AnswersID: 2381,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 4,
        AnswersTitle: '品牌宣传与市场拓展',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Exploring international cooperation opportunities',
        AnswersID: 2382,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 5,
        AnswersTitle: '寻求国际合作机会',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Participating in technical forums & academic exchange',
        AnswersID: 2383,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 6,
        AnswersTitle: '参与技术论坛与学术交流',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Identifying potential enterprises and investment projects for implementation',
        AnswersID: 2384,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 7,
        AnswersTitle: '寻找合适落地企业/投资项目',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'In-depth coverage and interviews',
        AnswersID: 2385,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 8,
        AnswersTitle: '深入行业峰会采访报道',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Others',
        AnswersID: 2386,
        AnswersInputText: '请输入',
        AnswersIsInput: true,
        AnswersSort: 9,
        AnswersTitle: '其他',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
    ]
  }
]
